import React from 'react';
import Badge from '../Badge';
import styled from 'styled-components';

const activeTabStyle = {
    borderBottom: 2,
    borderBottomColor: '#2e82ff',
    borderBottomStyle: 'solid',
};

const TabLi = styled.li`
    border-bottom: ${({ isActive }) => isActive ? '2px' : '0'};
    border-bottom-color: #2e82ff;
    border-bottom-style: solid;
`;

export default (props) => (
    <TabLi
        isActive={props.isActive}
        style={props.StyleProps}
        onClick={(event) => {
            event.preventDefault();
            props.onClick(props.tabIndex);
        }}
    >
        <a
            style={{ color: props.isActive === false && 'rgb(78, 78, 78)' }}>
            {props.title}
            {props.badge && <span style={{ position: "absolute", top: 15 }}><Badge /></span>}
        </a>
    </TabLi>
);


// WEBPACK FOOTER //
// ./src/components/tabs/Tab.js